import React, { useContext } from 'react'
import MobileHeader from '@pcln/mobile-header'
import { Box } from 'pcln-design-system'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import {
  ANALYTICS_CATEGORY_FLIGHTS,
  ANALYTICS_CATEGORY_PACKAGES
} from '@/constants/analytics'

const ANALYTICS_CATEGORY: Record<string, string> = {
  flights: ANALYTICS_CATEGORY_FLIGHTS,
  packages: ANALYTICS_CATEGORY_PACKAGES
}

const MobileHeaderWrapper = ({
  selectedProductName,
  children,
  ...props
}: {
  selectedProductName: string
  children: React.ReactNode
} & Record<string, unknown>) => {
  const { key = '' } = useContext(BootstrapDataContext)
  const category = ANALYTICS_CATEGORY[key]

  return (
    <Box
      {...props}
      mt={2}
      boxShadowSize="xl"
      rounded="round"
      borderRadius="2xl"
    >
      <Box mb="10px">
        <MobileHeader
          analyticsCategory={category}
          items={MobileHeader.itemsRefresh}
          mustRefreshIcons
          selectedItem={selectedProductName}
        />
      </Box>
      {children}
    </Box>
  )
}

export default MobileHeaderWrapper
